import { createApp } from './app.js'
import axios from 'axios'
import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar'
import { LocalNotifications } from '@capacitor/local-notifications';


axios.defaults.baseURL = 'https://app.dabulgaria.bg'
const { app, router, store } = createApp({
  axios: axios,
  url: decodeURIComponent(window.location.pathname)
})

if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
}

function foregrndLocalNotif(notification) {
  LocalNotifications.schedule({
    notifications: [
      {
        id: 1,
        title: notification.title,
        body: notification.body,
        schedule: { at: new Date(Date.now() + 1000 * 1) },
        extra: notification.data,
      },
    ],
  });
}

router.onReady(async () => {
  document.getElementById('spinner').style.display = 'none'
  if (Capacitor.getPlatform() === 'android') {
    await StatusBar.setBackgroundColor({ color: '5b2869' })
  }

  /**
   * Handle push notifications
   */
  if (Capacitor.isPluginAvailable('PushNotifications')) {
    await PushNotifications.requestPermissions()
    await PushNotifications.register()

    await PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification) => {
        //only for android foreground push notification
        //since capacitor has still not implemented tap on android //foreground notif
        if (Capacitor.isNativePlatform && Capacitor.getPlatform === 'android') {
          await PushNotifications.getDeliveredNotifications().then((x) => {
            PushNotifications.removeDeliveredNotifications(x);
          });
          foregrndLocalNotif(notification);
        }
      },
    );

    await PushNotifications.addListener('pushNotificationActionPerformed', (payload) => {
      if (payload.actionId === 'tap') {
        if (payload.notification.data.url !== false) {
          // go to notification page
          router.push(payload.notification.data.url)
        }
      }
    })

    await LocalNotifications.addListener(
      'localNotificationActionPerformed',
      (payload) => {
        if (payload.actionId === 'tap') {
          if (payload.notification.extra.url !== false) {
            // go to notification page
            router.push(payload.notification.extra.url)
          }
        }
      },
    )
  }

  /**
   * Handle deep links
   */
  if (Capacitor.isPluginAvailable('App')) {
    App.addListener('appUrlOpen', incoming => {
      let url = incoming.url.replace('https://', '').split('/')
      url.shift()
      router.push(url.join('/'))
    })
  }

  app.$mount('#app')
})
